// Service Worker Registration with Auto-Update
let swReg = null;

export const registerServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/service-worker.js')
        .then(registration => {
          console.log('✅ Service Worker registered successfully:', registration);
          swReg = registration;

          // Check for updates on page load only (removed aggressive 30s interval)
          // The browser will check for updates naturally on page navigation
          
          // When a new Service Worker is ready, show notification (don't auto-reload)
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            console.log('📝 New Service Worker found');

            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'activated' && !navigator.serviceWorker.controller) {
                console.log('✅ New Service Worker activated');
                showUpdateNotification();
              }
            });
          });
        })
        .catch(error => {
          console.error('❌ Service Worker registration failed:', error);
        });
    });

    // Removed controllerchange listener that could cause loops
  } else {
    console.warn('⚠️ Service Workers not supported in this browser');
  }
};

function showUpdateNotification() {
  console.log('💡 New app version available! Refresh page to update.');
  // You can show a toast/banner here
};

export const unregisterServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations()
      .then(registrations => {
        registrations.forEach(registration => registration.unregister());
      })
      .catch(error => console.error('Failed to unregister service worker:', error));
  }
};
